import { render, staticRenderFns } from "./TahsilatDusmeSirasi.vue?vue&type=template&id=d364f3b8&scoped=true"
import script from "./TahsilatDusmeSirasi.vue?vue&type=script&lang=ts"
export * from "./TahsilatDusmeSirasi.vue?vue&type=script&lang=ts"
import style0 from "./TahsilatDusmeSirasi.vue?vue&type=style&index=0&id=d364f3b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d364f3b8",
  null
  
)

export default component.exports